class ContentImage{
    constructor(data){
       this.update(data);
    }

    update(data){
        this.mobile = data.mobile;
        this.desktop = data.desktop;
        this.banner = data.banner;
        this.banner_mobile = data.banner_mobile;
        this.background = data.background;
        this.background_mobile = data.background_mobile;
        this.alt = data.alt;
    }
}

export default class MovieImage
{
    constructor(data)
    {
        this.featured = new ContentImage(data.featured || {});
        this.event = new ContentImage(data.event || {});
        this.promo = new ContentImage(data.promo || {});
        this.standard = new ContentImage(data.standard|| {});
    }

    setPromo(promoImages){
        this.promo.update(promoImages);
    }

    setEvent(eventImages){
        this.event.update(eventImages);
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/MovieImage.js